import numeral from 'numeral'
import { CRYPTO_CURRENCY_SYMBOL } from 'constants'

export default function assetsFormatter(value, noCurrency = null) {
    let parsedValue = numeral(numeral(value).value()/100).format('0,0')
    if (noCurrency !== null) {
        return parsedValue
    }
    return CRYPTO_CURRENCY_SYMBOL + ' '+ parsedValue
}